import { render, staticRenderFns } from "./Proceedings.vue?vue&type=template&id=2db9357d&scoped=true"
import script from "./Proceedings.vue?vue&type=script&lang=js"
export * from "./Proceedings.vue?vue&type=script&lang=js"
import style0 from "./Proceedings.vue?vue&type=style&index=0&id=2db9357d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9357d",
  null
  
)

export default component.exports